import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import PropTypes from 'prop-types';
import classNames from 'classnames';
var emptyFn = function () { };
injectStyle("components/DatePicker/rc-calendar/style/common/OkButton.css", "[data-dui-0-122-5~=\"dui-calendar-ok-btn\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:82px;height:36px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background:#1e6fff;border-radius:4px;color:#fff;font-size:14px}[data-dui-0-122-5~=\"dui-calendar-ok-btn\"]:hover{background:#175ceb}[data-dui-0-122-5~=\"dui-calendar-ok-btn-disabled\"],[data-dui-0-122-5~=\"dui-calendar-ok-btn-disabled\"]:hover{background:#f5f5f5;color:var(--text-weak,rgba(0,0,0,.24));cursor:not-allowed!important}");
export default function OkButton(_a) {
    var _b;
    var prefixCls = _a.prefixCls, locale = _a.locale, okDisabled = _a.okDisabled, onOk = _a.onOk;
    return (h("span", { role: "button", tabIndex: "0", className: classNames(prefixCls + "-ok-btn", (_b = {},
            _b[prefixCls + "-ok-btn-disabled"] = okDisabled,
            _b)), onClick: okDisabled ? null : onOk, onKeyDown: emptyFn }, locale.ok));
}
OkButton.propTypes = {
    locale: PropTypes.shape({
        ok: PropTypes.string,
    }),
    okDisabled: PropTypes.bool,
    prefixCls: PropTypes.string,
    onOk: PropTypes.func,
};
OkButton.defaultProps = {
    locale: {},
    okDisabled: false,
    onOk: emptyFn,
    prefixCls: '',
};
